import React, { useState } from "react";
import yerlembg from "../images/yerlemicon.svg";
import { Checkbox } from "primereact/checkbox";
import { Typography } from "@mui/material";
import { Button } from 'primereact/button';


export default function Mail({ setSidebarVisible }) {
  const [selectedApp, setSelectedApp] = useState(null);
  return (
    <div className="w-full h-full py-4 px-36 ">
      <div className="absolute top-2 left-2">
        <Button
          severity="info"
          label="Menu"
          icon="pi pi-bars"
          onClick={() => setSidebarVisible((visible) => !visible)}
        />
      </div>
      <div className="relative flex h-full items-center justify-center gap-6 flex-col">
        <img
          src={yerlembg}
          alt="Logo"
          className="absolute h-full object-cover z-0 "
        />
        <div className="flex flex-row justify-around gap-4 p-4">
          <div className="flex gap-2 items-center justify-center">
            <Checkbox
              value="algida"
              onChange={() =>
                selectedApp === "algida"
                  ? setSelectedApp(null)
                  : setSelectedApp("algida")
              }
              checked={selectedApp === "algida"}
            ></Checkbox>
            <Typography variant="h6">Algida</Typography>
          </div>
          <div className="flex gap-2 items-center justify-center">
            <Checkbox
              value="omo"
              onChange={() =>
                selectedApp === "omo"
                  ? setSelectedApp(null)
                  : setSelectedApp("omo")
              }
              checked={selectedApp === "omo"}
            ></Checkbox>
            <Typography variant="h6">Omo</Typography>
          </div>
        </div>
        <Button label="Raporları gönder" className="p-button-raised " />

     </div>
    </div>
  );
}
